/* eslint-disable react/prop-types */
import Badge, { BadgeColor } from "components/v2/Badge/Badge";
import { FormattedMessage, IntlShape } from "react-intl";
import { Column } from "react-table";

function getParcelAccountColumns(intl: IntlShape) {
  const columns: Column<any>[] = [
    {
      id: "account_name",
      Header: () => <FormattedMessage id="settings.parcelAccounts.accountName" defaultMessage="Account Name" />,
      accessor: "account_name",
      Cell: ({ value }) => <span>{value}</span>,
      width: "100%",
    },
    {
      id: "provider_company_name",
      Header: () => <FormattedMessage id="settings.parcelAccounts.provider" defaultMessage="Provider" />,
      accessor: "provider_company_name",
      Cell: ({ value }) => <span>{value}</span>,
      width: "100%",
    },
    {
      id: "account_number",
      Header: () => <FormattedMessage id="settings.parcelAccounts.accountNumber" defaultMessage="Account Number" />,
      accessor: "account_number",
      Cell: ({ value }) => <span>{value}</span>,
      width: 218,
    },
    {
      id: "account_type_display",
      Header: () => <FormattedMessage id="settings.parcelAccounts.configuration" defaultMessage="Configuration" />,
      accessor: "account_type_display",
      Cell: ({ value }) => <span>{value}</span>,
      width: 159,
    },
    {
      id: "is_active",
      Header: () => <FormattedMessage id="settings.parcelAccounts.status" defaultMessage="Status" />,
      accessor: "is_active",
      Cell: ({ value }) => {
        const color: BadgeColor = value ? "success" : "gray";
        return (
          <Badge
            color={color}
            label={value ? intl.formatMessage({ id: "general.active" }) : intl.formatMessage({ id: "general.inActive" })}
            type="status-badge"
          />
        );
      },
      width: 114,
      align: "center",
    },
  ];

  return columns;
}

export default getParcelAccountColumns;
